import { useState } from "react";
import { API_URL } from "../../../utils/common";

export interface UpdateUserAdminRequest {
    id: number;
    nombre: string;
    idPerfil: number;
}

export interface UpdateUserAdminResponse {
    id: number;
    nombre: string;
    correo: string;
    idPerfil: number;
    estatus: number;
}

export const useUpdateUserAdmin = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [usuario, setUsuario] =
        useState<UpdateUserAdminResponse | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const actualizarUsuario = async (
        payload: UpdateUserAdminRequest
    ): Promise<UpdateUserAdminResponse | null> => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(
                `${API_URL}/cms/admin/usuarios/${payload.id}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        nombre: payload.nombre,
                        idPerfil: payload.idPerfil,
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Error al actualizar el usuario");
            }

            const data: UpdateUserAdminResponse =
                await response.json();

            setUsuario(data);

            return data;

        } catch (err: any) {

            console.error(err);

            setError(
                err.message || "Ocurrió un error"
            );

            return null;

        } finally {

            setLoading(false);

        }

    };

    return {
        usuario,
        loading,
        error,
        actualizarUsuario,
    };

};